import React from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { statusMessages } from 'helpers/orders';


const useStyles = makeStyles(() => ({
  synced: { color: '#0d7c02' },
  error: { color: '#df0123' },
  pending: { color: '#e38a15' },
  titleInfo: {
    color: '#4277C6',
    fontSize: '12px',
    fontWeight: 600,
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
  },
}));

const ERROR_MESSAGES = {
  duplicated_customer: 'Duplicated customer',
  customer_created_but_can_not_proceed: 'Customer was created successfully in Nextech, but response is incorrect',
  order_created_but_no_valid_response: 'Order was created successfully in Nextech, but response is incorrect',
  can_not_get_orders: 'Can\'t get orders from Nextech',
  invalid_phone_number: 'Invalid phone number format',
  email_not_found_and_phone_invalid: 'Patient not found by email and phone number is invalid',
};

const IntegrationInfo = ({ title, status, idLabel, orderId, errorType, orderEmail, onResolve }) => {
  const classes = useStyles();

  return (
    <div className="px-20 py-10">
      <h5 className={classes.titleInfo}>{title}</h5>
      <div>
        <span>
          Status: <b className={classes[status]}>{statusMessages[status]}</b>
        </span>
        <br />
        {status === 'synced' && <span>{idLabel}: {orderId}</span>}
        {status === 'error' && (
          <>
            <span>
              Error: <b className={classes[status]}>{ERROR_MESSAGES[errorType]}{['duplicated_customer'].includes(errorType) && `: ${orderEmail}`}</b>
            </span>
            {onResolve && (
              <Button color="primary" variant="contained" className="ml-4" onClick={onResolve}>
                Resolve
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

IntegrationInfo.defaultProps = {
  onResolve: null
};

export default IntegrationInfo;
